// Katalog Motor Yamaha - Data dari yamaha-motor.co.id
// Harga OTR Jakarta (referensi resmi). Gambar dari CDN Yamaha Indonesia.

const CDN = "https://www.yamaha-motor.co.id/uploads/products/featured_image/";
const ICON = "https://www.yamaha-motor.co.id/web_new/common/header/image/";

export const CATEGORIES = [
  { key: "Semua",    label: "Semua",    icon: null },
  { key: "MAXi",     label: "MAXi",     icon: `${ICON}icon6.png` },
  { key: "Classy",   label: "Classy",   icon: `${ICON}icon7.png` },
  { key: "Matic",    label: "Matic",    icon: `${ICON}icon1.png` },
  { key: "Sport",    label: "Sport",    icon: `${ICON}icon2.png` },
  { key: "Off-Road", label: "Off-Road", icon: `${ICON}icon3.png` },
  { key: "Moped",    label: "Moped",    icon: `${ICON}icon4.png` },
];

// specs helper
const s = (Mesin, Tenaga, Transmisi, Tangki, Berat, Fitur) => ({
  Mesin, Tenaga, Transmisi, Tangki, Berat, Fitur,
});

export const MOTORCYCLES = [
  // ============ MAXi ============
  { slug: "tmax", name: "TMAX", category: "MAXi", price_idr: 455000000,
    image: `${CDN}2026012112000740123E5134.png`, engine_cc: 562, priceLabel: "OTR Jakarta",
    popular: false, order: 1,
    specs: s("562cc, 2-Silinder, DOHC 4-Klep", "47,6 PS / 7.500 rpm", "V-Belt Otomatis (CVT)", "15 L", "220 kg", "TFT + Cruise Control + Riding Mode + ABS") },
  { slug: "xmax-250", name: "XMAX 250", category: "MAXi", price_idr: 70015000,
    image: `${CDN}2025092412293259576G76761.png`, engine_cc: 250, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: true, order: 2,
    specs: s("250cc, SOHC, Blue Core", "23 PS / 7.000 rpm", "V-Belt Otomatis (CVT)", "13 L", "179 kg", "TFT + Y-Connect + ABS + Traction Control") },
  { slug: "nmax-turbo", name: "NMAX", category: "MAXi", price_idr: 34565000,
    image: `${CDN}2025111019384188604L75511.png`, engine_cc: 155, priceLabel: "OTR Jakarta (Termasuk Aksesoris), Mulai Dari",
    popular: true, order: 3,
    specs: s("155cc, VVA, Blue Core", "15,4 PS / 8.000 rpm", "YECVT Turbo (Y-Shift)", "7,1 L", "131 kg", "TFT + Y-Connect + Riding Mode + Traction Control") },
  { slug: "aerox-alpha", name: "Aerox Alpha", category: "MAXi", price_idr: 30700000,
    image: `${CDN}2026020516255618687C33585.png`, engine_cc: 155, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: true, order: 4,
    specs: s("155cc, VVA, Blue Core", "15,4 PS / 8.000 rpm", "YECVT (Y-Shift)", "5,5 L", "125 kg", "TFT + Y-Connect + Riding Mode + ABS") },
  { slug: "lexi-lx-155", name: "LEXi LX 155", category: "MAXi", price_idr: 27850000,
    image: `${CDN}202601210138425928P94164.png`, engine_cc: 155, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: false, order: 5,
    specs: s("155cc, VVA, Blue Core", "15,1 PS / 8.000 rpm", "V-Belt Otomatis (CVT)", "4,2 L", "118 kg", "Smart Key + Y-Connect + ABS opsional") },
  { slug: "nmax-155", name: "NMAX 155", category: "MAXi", price_idr: 32175000,
    image: `${CDN}2023022109405058553S83237.png`, engine_cc: 155, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: false, order: 6,
    specs: s("155cc, VVA, Blue Core", "15,4 PS / 8.000 rpm", "V-Belt Otomatis (CVT)", "7,1 L", "127 kg", "Smart Key + Y-Connect + LCD Panel") },
  { slug: "aerox-155", name: "Aerox 155", category: "MAXi", price_idr: 29380000,
    image: `${CDN}2023102519190474792T91675.png`, engine_cc: 155, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: false, order: 7,
    specs: s("155cc, VVA, Blue Core", "15,4 PS / 8.000 rpm", "V-Belt Otomatis (CVT)", "5,5 L", "123 kg", "Y-Connect + LCD + Smart Motor Generation") },

  // ============ Classy ============
  { slug: "grand-filano", name: "Grand Filano", category: "Classy", price_idr: 28665000,
    image: `${CDN}2026012314263490145D59534.png`, engine_cc: 125, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: true, order: 10,
    specs: s("125cc, Hybrid, Blue Core", "8,3 PS / 6.500 rpm", "V-Belt Otomatis (CVT)", "4,4 L", "102 kg", "Hybrid + Smart Key + Y-Connect + LCD") },
  { slug: "fazzio", name: "Fazzio", category: "Classy", price_idr: 22820000,
    image: `${CDN}2026012315293027645K32651.png`, engine_cc: 125, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: true, order: 11,
    specs: s("125cc, Hybrid, Blue Core", "8,3 PS / 6.500 rpm", "V-Belt Otomatis (CVT)", "4,4 L", "95 kg", "Hybrid + Answer Back + USB Charging") },

  // ============ Matic ============
  { slug: "gear-ultima", name: "Gear Ultima", category: "Matic", price_idr: 20240000,
    image: `${CDN}202604021124218894J.png`, engine_cc: 125, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: true, order: 20,
    specs: s("125cc, Blue Core", "9,5 PS / 8.000 rpm", "V-Belt Otomatis (CVT)", "4,2 L", "97 kg", "Bagasi 23,3L + USB Charging + Front Pocket") },
  { slug: "gear-125", name: "GEAR 125", category: "Matic", price_idr: 19495000,
    image: `${CDN}2024031507431441417B35284.png`, engine_cc: 125, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: false, order: 21,
    specs: s("125cc, Blue Core", "9,5 PS / 8.000 rpm", "V-Belt Otomatis (CVT)", "4,2 L", "96 kg", "Bagasi Luas + Answer Back System") },
  { slug: "freego-125", name: "FreeGo 125", category: "Matic", price_idr: 22865000,
    image: `${CDN}202506091443425485Y97917.png`, engine_cc: 125, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: false, order: 22,
    specs: s("125cc, Blue Core", "9,5 PS / 8.000 rpm", "V-Belt Otomatis (CVT)", "4,2 L", "103 kg", "Bagasi 25L + Smart Key + Stop & Start") },
  { slug: "x-ride-125", name: "X-Ride 125", category: "Matic", price_idr: 21135000,
    image: `${CDN}2025070409402252373C51406.png`, engine_cc: 125, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: false, order: 23,
    specs: s("125cc, Blue Core", "9,5 PS / 8.000 rpm", "V-Belt Otomatis (CVT)", "4,2 L", "97 kg", "Ban Semi Trail + Ground Clearance Tinggi") },
  { slug: "mio-m3-125", name: "Mio M3 125", category: "Matic", price_idr: 18905000,
    image: `${CDN}2025051913533472814Q20921.png`, engine_cc: 125, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: false, order: 24,
    specs: s("125cc, Blue Core", "9,5 PS / 8.000 rpm", "V-Belt Otomatis (CVT)", "4,2 L", "94 kg", "Smart Stand Switch + Eco Indicator") },
  { slug: "fino-125", name: "Fino 125", category: "Matic", price_idr: 20400000,
    image: `${CDN}202302210939153521B87826.png`, engine_cc: 125, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: false, order: 25,
    specs: s("125cc, Blue Core", "9,3 PS / 8.000 rpm", "V-Belt Otomatis (CVT)", "4,2 L", "94 kg", "Front Pocket + Answer Back System") },

  // ============ Sport ============
  { slug: "xsr-155", name: "XSR 155", category: "Sport", price_idr: 40265000,
    image: `${CDN}2025012015110954865E18335.png`, engine_cc: 155, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: false, order: 30,
    specs: s("155cc, VVA, Liquid-Cooled", "19,3 PS / 10.000 rpm", "6-Speed Manual", "10 L", "134 kg", "Round LED Lamp + Assist & Slipper Clutch") },
  { slug: "r15", name: "R15", category: "Sport", price_idr: 42200000,
    image: `${CDN}2024072510414155568H76580.png`, engine_cc: 155, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: true, order: 31,
    specs: s("155cc, VVA, Liquid-Cooled", "19,3 PS / 10.000 rpm", "6-Speed Manual", "11 L", "141 kg", "USD Fork + Deltabox Frame + Quick Shifter") },
  { slug: "r25", name: "R25", category: "Sport", price_idr: 76250000,
    image: `${CDN}2025012015411993760O36900.png`, engine_cc: 250, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: false, order: 32,
    specs: s("249cc, 2-Silinder, DOHC", "35,5 PS / 12.000 rpm", "6-Speed Manual", "14 L", "170 kg", "ABS + Full LED + Assist & Slipper Clutch") },
  { slug: "mt-25", name: "MT-25", category: "Sport", price_idr: 66450000,
    image: `${CDN}2025012015192887371O6508.png`, engine_cc: 250, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: false, order: 33,
    specs: s("249cc, 2-Silinder, DOHC", "35,5 PS / 12.000 rpm", "6-Speed Manual", "14 L", "166 kg", "USD Fork + ABS + LED Full") },
  { slug: "mt-15", name: "MT-15", category: "Sport", price_idr: 41215000,
    image: `${CDN}2025012015144954158N49912.png`, engine_cc: 155, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: true, order: 34,
    specs: s("155cc, VVA, Liquid-Cooled", "19,3 PS / 10.000 rpm", "6-Speed Manual", "10 L", "138 kg", "LED Headlamp + Deltabox Frame") },
  { slug: "vixion-155", name: "VIXION 155", category: "Sport", price_idr: 31450000,
    image: `${CDN}2023022109421344125G78257.png`, engine_cc: 155, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: false, order: 35,
    specs: s("155cc, VVA, Liquid-Cooled", "16,6 PS / 10.000 rpm", "5-Speed Manual", "12 L", "132 kg", "Deltabox Frame + LED Lamp") },

  // ============ Off-Road ============
  { slug: "wr155r", name: "WR155R", category: "Off-Road", price_idr: 41275000,
    image: `${CDN}2026012216283431324H51389.png`, engine_cc: 155, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: false, order: 40,
    specs: s("155cc, VVA, Liquid-Cooled", "16,3 PS / 10.000 rpm", "6-Speed Manual", "8,1 L", "134 kg", "Long Travel Suspension + Dual Purpose Tire") },
  { slug: "yz125x", name: "YZ125X", category: "Off-Road", price_idr: 99800000,
    image: `${CDN}202606031052219193A.png`, engine_cc: 125, priceLabel: "Off The Road Jakarta, Mulai Dari",
    popular: false, order: 41,
    specs: s("125cc, 2-Stroke, Liquid-Cooled", "34 PS (kompetisi)", "6-Speed Manual", "7,5 L", "96 kg", "Motocross/Enduro Competition") },
  { slug: "yz250x", name: "YZ250X", category: "Off-Road", price_idr: 132000000,
    image: `${CDN}202606031053343044T.png`, engine_cc: 250, priceLabel: "Off The Road Jakarta, Mulai Dari",
    popular: false, order: 42,
    specs: s("249cc, 2-Stroke, Liquid-Cooled", "48 PS (kompetisi)", "5-Speed Manual", "8,2 L", "104 kg", "Enduro Competition + Wide Ratio Trans") },
  { slug: "yz250fx", name: "YZ250FX", category: "Off-Road", price_idr: 140000000,
    image: `${CDN}202606031050479381F.png`, engine_cc: 250, priceLabel: "Off The Road Jakarta, Mulai Dari",
    popular: false, order: 43,
    specs: s("250cc, 4-Stroke, DOHC, Liquid-Cooled", "42 PS (kompetisi)", "6-Speed Manual", "7,9 L", "112 kg", "Cross-Country + Electric Starter") },

  // ============ Moped ============
  { slug: "mx-king-150", name: "MX King 150", category: "Moped", price_idr: 29200000,
    image: `${CDN}202606190939128383S.png`, engine_cc: 150, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: false, order: 50,
    specs: s("150cc, DOHC, Liquid-Cooled", "15,8 PS / 10.000 rpm", "5-Speed Manual", "4,2 L", "119 kg", "LED Lamp + Deltabox Frame") },
  { slug: "jupiter-z1", name: "Jupiter Z1", category: "Moped", price_idr: 22580000,
    image: `${CDN}2025061108344332282O17129.png`, engine_cc: 115, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: false, order: 51,
    specs: s("115cc, Fuel Injection", "9,5 PS / 7.750 rpm", "4-Speed Manual", "4,2 L", "98 kg", "Electric Starter + Sport Digital Speedometer") },
  { slug: "vega-force", name: "Vega Force", category: "Moped", price_idr: 19900000,
    image: `${CDN}2023060510573539478H29934.png`, engine_cc: 115, priceLabel: "OTR Jakarta, Mulai Dari",
    popular: false, order: 52,
    specs: s("115cc, Blue Core", "8,5 PS / 7.500 rpm", "4-Speed Manual", "4,2 L", "97 kg", "Electric Starter + Alloy Wheel") },
];

export const POPULAR = MOTORCYCLES.filter((m) => m.popular).sort((a, b) => a.order - b.order);
export const getMotorBySlug = (slug) => MOTORCYCLES.find((m) => m.slug === slug);

export const PRICE_MIN = Math.min(...MOTORCYCLES.map((m) => m.price_idr));
export const PRICE_MAX = Math.max(...MOTORCYCLES.map((m) => m.price_idr));
